import { AxiosError } from "axios"
import StatusCode from "../util/StatusCode"
import { CoreDisplayableRef } from "./CoreModels"

export interface CoreClassroomAdminDashboard {
    classrooms: number
    synched: number
    orphanRisk: number
    orphaned: number
    missingTeachers: number
}

export interface CoreClassroomAdminDashboardOwnerCount {
    owner: string
    classrooms: number
}

export interface CoreClassroomAdminDashboardSchoolCount {
    school: string
    classrooms: number
}

export interface CoreClassroomAdminClassroomListing {
    classroomId: string,
    classroomName:string,
    ownerName?: string
    ownerEmail?: string
    state: CoreClassroomAdminClassroomState,
    synched: boolean,
    teacherCount: number,
    studentCount: number,
    creationTime: string
};

export interface CoreClassroomAdminClassroom {
    classroomId: string,
    classroomName: string,
    ownerName?: string
    ownerEmail?: string
    state: CoreClassroomAdminClassroomState,
    synched: boolean,
    teacherCount: number,
    studentCount: number,
    creationTime: string
    updateTime: string
    descriptionHeading?: string
    section?: string
    subject?: string
    room?: string
    enrollmentCode?: string
    alternateLink?: string
    guardiansEnabled: boolean
    orphaned: boolean
    ownerId: string
    ownerState: ClassroomAdminOwnerState
    activity?: CoreDisplayableRef
    group?: CoreDisplayableRef
    schoolUnit?: CoreDisplayableRef
};


export interface CoreClassroomAdminClassroomState {
    courseState: string,
    stateInformation: string
}
export enum CoreClassroomAdminCourseState {
    Unknown = 0,
    CourseStateUnspecified = 1,
    Active = 2,
    Archived = 3,
    Provisioned = 4,
    Declined = 5,
    Suspended = 6
}
export enum CoreClassroomAdminClassroomStateInfo {
    Undefined = 0,
    Orphaned = 1,
    OrphaneRisk = 2,
}

export enum ClassroomAdminOwnerState {
    Unknown = 0,
    Active = 1,
    Suspended = 2,
    Deleted = 3,
}

export enum AddClassroomMembersType {
    Teacher = 0,
    Student = 1
}

export interface AddClassroomMembers {
    type: AddClassroomMembersType
    members: string[]
}

export interface AddedClassroomMember {
    email: string
    success: boolean
    error?: string
}

export interface ClassroomResult {
    classroomId: string;
    code: StatusCode;
    error?: AxiosError;
}